import React from 'react';
import Modal from '@omilia/modal';

import ModalButtons from 'components/ModalButtons';
// @ts-ignore
import messages from 'constants/messages';
import { SContainer } from '../styled';

type Props = {
  branchName: string;
  onCancel: () => void;
  onMergeBranch: () => void;
};

const MergeRequestBranchModal = ({
  branchName,
  onCancel,
  onMergeBranch,
}: Props) => (
  <Modal
    open
    shouldCloseOnEscPress
    glyph="notification-verify"
    hasBackdrop={false}
    subtitle={`${branchName} into its parent branch`}
    title="Merge Branch"
  >
    <SContainer>
      <span data-test="project-deletion-message">
        <strong>Notice:</strong>
        {messages.VERSION_CONTROL.MERGE_MODAL.PROJECT_DELETION_MESSAGE}
      </span>
      <ModalButtons
        primary={{
          text: 'Merge Branch',
          onClick: onMergeBranch,
          type: 'button',
        }}
        secondary={{ text: 'Cancel', onClick: onCancel }}
      />
    </SContainer>
  </Modal>
);

export default MergeRequestBranchModal;
